import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";

const EntityContext = createContext(null);

export function EntityProvider({ children }) {
  const { user } = useAuth();
  const [entities, setEntities] = useState([]);
  const [currentEntityId, setCurrentEntityId] = useState(() => localStorage.getItem("rops_entity") || "GROUPE");

  useEffect(() => {
    if (!user) return;
    api.get("/entities").then(({ data }) => setEntities(data)).catch(() => {});
  }, [user]);

  const selectEntity = (id) => {
    setCurrentEntityId(id);
    localStorage.setItem("rops_entity", id);
  };

  const currentEntity = entities.find((e) => e.id === currentEntityId) || { id: "GROUPE", name: "GROUPE", color: "#D6F32F", sub: "Vue consolidée" };

  return (
    <EntityContext.Provider value={{ entities, currentEntityId, currentEntity, selectEntity }}>
      {children}
    </EntityContext.Provider>
  );
}

export const useEntity = () => useContext(EntityContext);
